import React from "react";
import { useIssuesFetchParams } from "@adsk/acc-issues-core/state/issuesFetchParams/useIssueFetchParams";
import { useCallback } from "react";
import { IssueFilter } from "@adsk/acc-issues-types";
import { IssueFilterForm } from "@adsk/acc-issues-common/components/form/IssueFilterForm";
import { CenteredSpinner } from "@adsk/acc-issues-common/components/primitive/CenteredSpinner";
import { useDispatch } from "@adsk/acc-issues-core/state/redux/hooks";
import { clearSelectedIdsAction } from "@adsk/acc-issues-core/state/redux/ducks/issueTableSelection";
import { useIsMetadataLoading } from "@adsk/acc-issues-common/hooks/state/useIsMetadataLoading";
import { trackFilterApply } from "../../../utils/analytics/trackFiltering";
import { useUserFetchParams } from "@adsk/acc-issues-core/state/issuesFetchParams/UserFetchParamsProvider";

const useHandleFilterChange = () => {
  const dispatch = useDispatch();
  const { handleFilterChange } = useUserFetchParams();
  return useCallback(
    (filtersDiff: Partial<IssueFilter>) => {
      handleFilterChange(filtersDiff);
      Object.keys(filtersDiff).forEach(filterKey => {
        trackFilterApply({
          field: filterKey,
          fieldValue: JSON.stringify(
            (filtersDiff as { [filterKeyName: string]: any })[filterKey]
          ),
        });
      });
      dispatch(clearSelectedIdsAction());
    },
    [handleFilterChange, dispatch]
  );
};

export const IssueFilterPanelBody = () => {
  const handleFilterChange = useHandleFilterChange();
  const { value: issuesFetchParams } = useIssuesFetchParams();
  const isMetadataLoading = useIsMetadataLoading();

  if (isMetadataLoading || !issuesFetchParams) {
    return <CenteredSpinner />;
  }

  return (
    <IssueFilterForm
      filters={issuesFetchParams.filterBy}
      handleFilterChange={handleFilterChange}
    />
  );
};
